import { IApiError } from '@/models/apiError.model';
import { IRobotsData } from '@/models/seo.model';

export const SEO_SLICE_NAME = 'seo';

export interface SeoState {
  robotsData: IRobotsData | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: SeoState = {
  robotsData: null,
  isLoading: false,
  error: null,
};
